<section id="tricks">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <app-v-two-section-title [titleSectionProp]="titleSectionProp"></app-v-two-section-title>
                <!-- <a class="button blue-btn gradient-btn button-icon" href="#"><span class="btn-effect"> Empezar ahora</span></a> -->
            </div>
            <div class="col-lg-6">
                <div class="popup-images align-right">
                    <div class="img-one wow zoomIn" data-wow-duration="0.6s">
                        <img src="./assets/sofbox-v2/images/home-7/final.svg" alt="image1">
                    </div>
                    <div class="d-block"></div>
                </div>
            </div>
        </div>
    </div>
</section>